import { Injectable } from '@angular/core'
import { ViewComponentsDialogComponent } from '../view-components-dialog/view-components-dialog.component'
import { MbModalService } from '../../../../shared/services/modal.service'
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap'

@Injectable({
  providedIn: 'root'
})
export class ViewComponentsDialogService {
  modalRef: NgbModalRef | null = null
  components: string[] = []

  constructor (protected modalService: MbModalService) { }

  open (components: any): void {
    const modalRef = this.modalService.open
              (ViewComponentsDialogComponent,
                { centered: true, scrollable: true, modalDialogClass: 'mb-ng-modal' } as any)
    modalRef.componentInstance.components = components
  }
}
